import React, { useEffect, useState } from "react";
import { Link, useLocation  } from "react-router-dom";
import axios from "axios";
import he from "he";
import image_logo from "../../assets/img/general/1assd.png";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

function Header() {
  const [allRecords, setAllRecords] = useState([]);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMobileMenu = () => {
    setMobileMenuOpen((prev) => !prev);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  useEffect(() => {
    (async () => await fetchMenueData())();
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  // ================= MENU HELPERS =================

  const getgrandSubMenu = (
    recordsArr,
    parentVal,
    item02Val = 0,
    item02bVal = 0,
  ) => {
    return recordsArr
      .filter(
        (item) =>
          item.item01 === parentVal &&
          item.item02 === item02Val &&
          Number(item.item02b) > Number(item02bVal),
      )
      .map((item, index) => (
        <li key={`${item.item01}-${index}`} className="dropdown">
          <Link
            to={
              item.linker !== "" && item.linker !== null
                ? item.linker
                : `/${he.decode(item.item03.replace(/ & /g, "_"))}/${item.item02b}`
            }
            target={item.triger}
            onClick={closeMobileMenu}
          >
            {he.decode(item.item03)}
          </Link>
        </li>
      ));
  };

  const getSubMenu = (recordsArr, parentVal, item02Val = 0, item02bVal = 0) => {
    return recordsArr
      .filter(
        (item) =>
          item.item01 === parentVal &&
          Number(item.item02) > Number(item02Val) &&
          Number(item.item02b) === Number(item02bVal),
      )
      .map((item, index) => {
        const currentVal = item.item02;

        const hasGrandChildren = recordsArr.some(
          (i) =>
            i.item01 === parentVal &&
            i.item02 === currentVal &&
            i.item02b > item02bVal,
        );

        return (
          <li key={`${item.item01}-${index}`} className="dropdown">
            <Link
              to={
                item.linker !== "" && item.linker !== null
                  ? item.linker
                  : `/${he.decode(item.item03.replace(/ & /g, "_"))}/${item.item02}`
              }
              target={item.triger}
              onClick={closeMobileMenu}
            >
              {he.decode(item.item03)}
            </Link>

            {hasGrandChildren && (
              <ul>{getgrandSubMenu(recordsArr, parentVal, currentVal)}</ul>
            )}
          </li>
        );
      });
  };

  async function fetchMenueData() {
    try {
      await axios.get("sanctum/csrf-cookie");

      const responses = await Promise.all([
        axios.get(
          `${BASE_URL}pagdatab?itemName[eq]=menue_tab&status02[eq]=publish`,
        ),
      ]);

      const [menueData] = responses;

      if (menueData.data.status === 200) {
        setAllRecords(menueData.data.allData || []);
      }
    } catch (error) {
      console.log("Error loading menu");
    }
  }

  // ================= UI =================

  return (
    <>
      {/* TOPBAR (unchanged) */}
      <div className="topbar d-flex align-items-center">
        <div className="container d-flex justify-content-center justify-content-md-between">
          <div className="contact-info d-flex align-items-center">
            <i className="fa-solid fa-envelope d-flex align-items-center">
              <Link
                to="mailto:info@fmhud.gov.ng"
                aria-label="Send email to FMHUD"
              >
                info@fmhud.gov.ng
              </Link>
            </i>
            <i className="fa-solid fa-phone d-flex align-items-center ms-4">
              <Link to="tel:+2348061743313" aria-label="Call FMHUD">
                +234 8 061 7433 13
              </Link>
            </i>
          </div>
        </div>
      </div>

      {/* BRANDING */}
      <div className="branding d-flex align-items-cente border">
        <div className="container position-relative d-flex align-items-center justify-content-between">
          <Link
            to="#"
            className="orglogo d-flex align-items-center gap-3 flex-wrap"
          >
            <img
              loading="eager"
              decoding="async"
              src={image_logo}
              alt="orglogo"
              className="img-fluid orglogo-img"
             
            />

            <div className="orglogo-text">
              <h1
                className="sitename mb-0 fw-bold pb-2"
                style={{
                  fontSize: "clamp(0.7rem, 2vw, 1.15rem)",
                  lineHeight: "1.1",
                }}
              >
                FEDERAL MINISTRY OF
              </h1>

              <h1
                className="sitename mb-0 fw-bold pb-2"
                style={{
                  fontSize: "clamp(0.9rem, 3vw, 1.55rem)",
                  lineHeight: "1.1",
                }}
              >
                HOUSING & URBAN DEVELOPMENT
              </h1>

              <h2
                className="sitename mt-0 text-danger"
                style={{
                  fontSize: "clamp(0.6rem, 1.8vw, 1rem)",
                  lineHeight: "1.1",
                }}
              >
                Federal Republic of Nigeria
              </h2>
            </div>
          </Link>

          {/* ================= NAV ================= */}

          <nav
            id="navmenu"
            className={`navmenu ${mobileMenuOpen ? "mobile-nav-active" : ""}`}
          >
            <ul>
              {allRecords.map((item, index) => {
                if (Number(item.item02) === 0 && Number(item.item02b) === 0) {
                  const hasChildren = allRecords.some(
                    (i) => i.item01 === item.item01 && i.item02 > 0,
                  );

                  return (
                    <li key={`top-${index}`} className="dropdown">
                      <Link
                        to={
                          item.linker !== "" && item.linker !== null
                            ? item.linker
                            : `/${he.decode(item.item03.replace(/ & /g, "_"))}/${item.item01}`
                        }
                        target={item.triger}
                        onClick={closeMobileMenu}
                      >
                        {he.decode(item.item03)}
                      </Link>

                      {hasChildren && (
                        <ul>{getSubMenu(allRecords, item.item01)}</ul>
                      )}
                    </li>
                  );
                }

                return null;
              })}
            </ul>

            {/* HAMBURGER */}
            <i
              className={`mobile-nav-toggle d-xl-none fa-solid ${
                mobileMenuOpen ? "fa-xmark" : "fa-bars"
              }`}
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              style={{ cursor: "pointer" }}
            />
          </nav>

          {/* ================= OVERLAY (IMPORTANT FIX) ================= */}
          {mobileMenuOpen && (
            <div className="mobile-menu-overlay" onClick={closeMobileMenu} />
          )}
        </div>
      </div>
    </>
  );
}

export default Header;
